import { Collapse, Button, Tooltip, Row, Col } from 'antd';
import { useState } from 'react';
import Title from '../Title';
import Description from '../Description';
import SearchLevels from './SearchLevels';
import NutrientIssues from './NutrientIssues';
import NutrientImages from './NutrientImages';
import NutrientDistricts from './NutrientDistricts';
import NutrientWordCloud from './NutrientWordCloud';
import NutrientDiseases from './NutrientDiseases';
import LinkList from '../LinkList';

const { Panel } = Collapse;

const Nutrient = (props) => {
  const [usePublico, setUsePublico] = useState(false);
  const usePublicoOnChangeHandler = () => {
    setUsePublico(!usePublico);
  };

  const image = `/images/${props.path.split('/')[1]}.png`;

  return (
    <div>
      <Title label={props.label} isHome={false}></Title>

      <Row justify="space-between">
        <Col span={7}>
          <Description
            style={{ marginBottom: '1em', fontSize: '18px', padding: 0 }}
            label={props.customWikiPt}
            customWikiEn={props.customWikiEn}></Description>
          <img src={image} style={{ height: '200px', width: '200px' }}></img>
        </Col>
        <Col span={16}>
          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel header="Wordcloud" key="1">
              <NutrientWordCloud label={props.label} className="bg-alt-2"></NutrientWordCloud>
            </Panel>
          </Collapse>

          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel header="Distribuição Geográfica" key="1">
              <NutrientDistricts label={props.label}></NutrientDistricts>
            </Panel>
          </Collapse>

          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel header="Distribuição Temporal" key="1">
              <SearchLevels label={props.label} className="bg-alt-2"></SearchLevels>
            </Panel>
          </Collapse>

          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel header="Doenças" key="1">
              <NutrientDiseases
                label={props.label}
                className="bg-alt-2"
                style={{ marginBottom: '1em' }}></NutrientDiseases>
            </Panel>
          </Collapse>

          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel header="Contextos Sociais e Económicos" key="1">
              <NutrientIssues label={props.label} className="bg-alt-2" style={{ marginBottom: '1em' }}></NutrientIssues>
            </Panel>
          </Collapse>

          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel header="Imagens" key="1">
              <NutrientImages label={props.label} className="bg-alt-2"></NutrientImages>
            </Panel>
          </Collapse>

          <Collapse collapsible="header" size="large" style={{ marginBottom: 10 }}>
            <Panel
              header="Páginas do Arquivo"
              key="1"
              extra={
                <Button
                  type="primary"
                  shape="round"
                  size="small"
                  onClick={usePublicoOnChangeHandler}
                  style={{ backgroundColor: usePublico ? 'red' : 'white' }}>
                  <span style={{ color: usePublico ? 'white' : 'red', fontFamily: 'Merriweather' }}>
                    <Tooltip title="Filtrar pelo jornal Público">
                      <span>
                        <b>P</b>
                      </span>
                    </Tooltip>
                  </span>
                </Button>
              }>
              <LinkList label={props.label} className="bg-alt-2" usePublico={usePublico}></LinkList>
            </Panel>
          </Collapse>
        </Col>
      </Row>
    </div>
  );
};

export default Nutrient;
